import { FunctionComponent, useState } from 'react'
import { useMutation } from '@apollo/client'
import styles from './forgottenPassword.module.scss'
import { REQUEST_CHANGE_PASSWORD } from '@/modules/API/software/passwordHandler'
import LoggedOutNav from '@/components/Nav/LoggedOutNav/LoggedOutNav'
import Title from '@/components/_custom/Title/title'
import UserInput from '@/components/_custom/UserInput/userInput'
import ButtonText from '@/components/_custom/Buttons/ButtonText/ButtonText'
import { Link } from 'react-router-dom'
import ErrorMessage from '@/components/_custom/ErrorMessage/ErrorMessage'
import { useTranslation } from 'react-i18next'
import validator from 'validator'

const RequestNewPassword: FunctionComponent = () => {
    const { t } = useTranslation()

    const [email, setEmail] = useState<string>(() => {
        return localStorage.getItem('email') || ''
    })

    const [emailValid, setEmailValid] = useState<boolean>(validator.isEmail(email) && email !== '')

    const [isSend, setIsSend] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string>('')

    const [requestChangePassword] = useMutation(REQUEST_CHANGE_PASSWORD, {
        variables: { email: email },
        onCompleted: () => {
            setIsSend(true)
            setErrorMessage('')
        },
        onError: (error) => {
            switch (error.message.split('Message: ')[0]) {
                case 'User not found':
                    setEmailValid(false)
                    setErrorMessage(t('emailNotFound'))
                    break
                case 'Permission denied':
                    setErrorMessage(t('changePasswordResetError'))
                    break
                default:
                    setErrorMessage(t('generalError'))
                    break
            }
        }
    })

    async function resetPassword(): Promise<void> {
        await requestChangePassword()
    }

    return (
        <div className={styles.PagePosition}>
            <LoggedOutNav />
            <div className={styles.PasswordPlacement}>
                <div className={styles.Form}>
                    <div className={styles.Title}>
                        <Title text={t('forgottenPassword')} />
                    </div>
                    {(!isSend && (
                        <>
                            <div className={styles.Input}>
                                <UserInput
                                    id='email'
                                    label={t('email')}
                                    type={'text'}
                                    unallowedCharacters={'email'}
                                    verify={'email'}
                                    required
                                    fullWidth
                                    value={email}
                                    setValue={setEmail}
                                    setValid={setEmailValid}
                                />
                            </div>
                            <p className={styles.Text}>{t('forgotPasswordText')}</p>
                            {errorMessage && <ErrorMessage error={errorMessage} className={styles.ErrorPosition} />}
                            <ButtonText text={t('continue')} onClick={resetPassword} fullWidth disabled={!emailValid} />
                            <Link to='/' className={styles.Link}>
                                {t('returnToLogin')}
                            </Link>
                        </>
                    )) || (
                        <div className={styles.ValidationText}>
                            <p>
                                {t('passwordResetTextSuccess')}
                                <span className={styles.ColorSpan}>{email}</span>
                            </p>
                            <p>{t('passwordResetTextSuccessPart2')}</p>
                            <Link to='/' className={styles.Link}>
                                <ButtonText text={t('returnToLogin')} onClick={() => {}} fullWidth />
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default RequestNewPassword
